export const PATENT_LEVELS = [
    {
        min: 0,
        max: 10000,
        level: 0.5
    },
    {
        min: 10000,
        max: 25000,
        level: 1
    },
    {
        min: 25000,
        max: 50000,
        level: 1.5
    },
    {
        min: 50000,
        max: 100000,
        level: 2
    },
    {
        min: 100000,
        max: 200000,
        level: 2.5
    },
    {
        min: 200000,
        max: 500000,
        level: 3
    },
    {
        min: 500000,
        max: 1000000,
        level: 3.5
    },
    {
        min: 1000000,
        max: 2500000,
        level: 4
    },
    {
        min: 2500000,
        max: 5000000,
        level: 4.5
    },
    {
        min: 5000000,
        max: Infinity,
        level: 5
    }
];

export default (value) => {
    for (let i = 0; i < PATENT_LEVELS.length; i++) {
        const { min, max, level } = PATENT_LEVELS[i];
        if (min < value && max >= value) {
            return level;
        }
    }
    return 0;
};
